import { createContext, useContext } from "react";

export interface SubscriptionContext {
  isChannelPartnerAccount: boolean;
  hasUnlimitedUsers: boolean;
  subscriptionLoading: boolean;
}

export const SubscriptionContext = createContext<SubscriptionContext>({
  isChannelPartnerAccount: false,
  hasUnlimitedUsers: false,
  subscriptionLoading: true,
});

export const useSubscriptionContext = () => {
  const context = useContext(SubscriptionContext);

  if (!context) {
    throw new Error(
      "useSubscriptionContext must be used within SubscriptionContext"
    );
  }

  return context;
};
